export default {
   referral:{
    link : {
      title: 'Referral Program',
      code: {
        tabName: 'Linking Code',
        policyTitle: 'Refer Yisu Cloud and earn $10 per paid signup!',
        policy1: 'Referred users must be active for 30+ days and use at least $10 in payments to be counted as verified sales.',
        policy2: 'Payouts are finalized and issued on the business day following the 1st of each month.',
        policy3: 'Your referral link below uniquely identifies your account. Use this code when linking to yisu.com/intl and start earning today!',
        linkBtn: 'Get Your Link',
        shareYourLink: 'Share Your Link',
        linkDesc: 'Usage of this link is governed by the Yisu Cloud Referral Program Terms of Service. Terms subject to change at any time.',
        Terms: 'Click for Terms of Service',
        getLink: 'Get Your Link',
      },
      payouts: {
        tabName: 'Payouts',
        unpaidEarnings: 'Unpaid Earnings',
        earnings: 'Earnings (older than 30 days):',
        earningsNotice1: 'Rewards will be credited to pending earnings on the first working day of the month after 30 days after the order is paid.',
        earningsNotice2: 'Once the minimum withdrawal conditions are met, the pending income will be withdrawn to the account on the working day after the 1st of each month.',
        payoutSettings: 'Payout Settings',
        payoutType: 'Payout Type: ',
        accountCredit: 'Account Credit (no payout minimum)',
        paypal: 'PayPal',
        minimumPayout: 'Minimum Payout: ',
        yourPayPalEmail: 'Your PayPal E-mail',
        updatePayoutSettings: 'Update Payout Settings',
        payoutHistory: 'Payout History',
        historyType1: 'Account Credit',
        historyType2: 'PayPal',
        method: 'Method',
        date: 'Date',
        amount: 'Amount',
        status: 'Status',
        issuedSuccessfully: 'Issued Successfully',
        issuedError: 'Issued Error',
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/referral.js